import { Component, OnInit } from '@angular/core';
import { PricebookService } from '../pricebook.service';
import { Status, Severity,Answer} from '../../constants/constants'
import { TitleCasePipe } from '@angular/common';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-discount-select',
  templateUrl: './discount-select.component.html',
  styleUrls: ['./discount-select.component.scss']
})
export class DiscountSelectComponent implements OnInit {

  options=[];
  answertypeConstants= Answer;
  statusConstants=Status;

  constructor(private pricebookService: PricebookService, private titleCasePipe: TitleCasePipe, private messageService: MessageService) { }

  ngOnInit(): void {
    this.loadPriceTierDiscountOption('TierApplicationRule');
  }

  loadPriceTierDiscountOption(name){
   this.pricebookService.getAllDiscountOption(name).subscribe(types=> {
      this.options = types;
   })
  }

  setDefault(value){
   this.pricebookService.setDefaultDiscountOption(value).then(() => {
    this.options?.forEach(element => {
      if(element.id!=value.id){
        element.isDefault=false;
      }
     });
     this.messageService.add({ severity: Severity.Success, summary: this.titleCasePipe.transform(Severity.Success), detail: 'Updated successfully...' });
  }).catch(() => {
    this.messageService.add({ severity: Severity.Error, summary: this.titleCasePipe.transform(Severity.Error), detail: 'Error occurred while saving data...' });
  });
}

}
